import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useUIStore } from "@store/ui.store";
import type { SettingsModalSections } from "./SettingsModal";

const settingsModalSections: Array<SettingsModalSections> = [
  "general",
  "integrations",
  "security",
];

const isSettingsModalSection = (
  value: string | null,
): value is SettingsModalSections =>
  settingsModalSections.includes(value as SettingsModalSections);

export const useSettingsModalFromUrl = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const openSettingsModal = useUIStore((state) => state.openSettingsModal);
  const closeSettingsModal = useUIStore((state) => state.closeSettingsModal);
  const initialSection = useRef(searchParams.get("settings_modal"));

  useEffect(() => {
    const section = initialSection.current;
    if (isSettingsModalSection(section)) {
      openSettingsModal(section);
    }
  }, [openSettingsModal]);

  const handleCloseSettingsModal = () => {
    closeSettingsModal();
    if (initialSection.current) {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.delete("settings_modal");
          return next;
        },
        { replace: true },
      );
    }
  };

  return { handleCloseSettingsModal };
};
